import React from "react";
import { useInfiniteScroll } from "@hooks/useInfiniteScroll";
import { NoData } from "@components/common/NoData/NoData";
import Spinner from "@components/common/Spinner";
import type { InfiniteScrollProps } from "./types/types";
import { useTranslation } from "react-i18next";

const InfiniteScroll = <T extends { id: string | number }>({
	items,
	renderItem,
	hasNextPage,
	fetchNextPage,
	isFetching,
	noDataMessage,
	className = "gap-5 grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2",
	scrollRootId,
}: InfiniteScrollProps<T>) => {
	const lastItemRef = useInfiniteScroll(isFetching, hasNextPage, fetchNextPage, scrollRootId);
	const { t } = useTranslation();
	if (items.length === 0) {
		return <NoData msg={noDataMessage} />;
	}

	return (
		<div id={scrollRootId} className={className}>
			{items.map((item, index) => (
				<React.Fragment key={item.id}>
					{renderItem(item, index)}
					{index === items.length - 1 && <div ref={lastItemRef} />}
				</React.Fragment>
			))}
			{isFetching && (
				<div className="col-span-full flex flex-col items-center justify-center gap-2 py-4">
					<Spinner size={36} />
					<span className="text-sm text-gray-600">{t("psdaCommon.common.loading")}</span>
				</div>
			)}
		</div>
	);
};

export default InfiniteScroll;
